<template>
    <div :data-testid="dataTestid" class="profile-common__freelancing-experience__card">
        <h2 :data-testid="`${dataTestid}--title`">{{ props.title }}</h2>
        <MaltImg :data-testid="`${dataTestid}--img`" :src="props.illustration" width="130" height="110" :alt="props.title" />
    </div>
</template>
<script setup lang="ts">
    import {MaltImg} from '#components';

    const props = defineProps<{
        title: string;
        illustration: string;
        dataTestid: string;
    }>();
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .profile-common__freelancing-experience__card {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: var(--joy-core-spacing-2);
        align-items: center;

        border: 1px solid;
        border-color: var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-3);

        overflow: hidden;

        padding: var(--joy-core-spacing-8);
        margin: 0;

        @include mq.screen_xs() {
            flex-direction: row-reverse;
            justify-content: flex-end;
            padding: var(--joy-core-spacing-4);
        }

        h2 {
            @include text.getFontBySize(primary-650);
            text-align: left;
        }

        img {
            max-height: 100%;
        }
    }
</style>
